export function ListItemFourthIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.2244 10.9894V8.23625L8.3675 10.9894H10.2244ZM10 1.875C5.5125 1.875
        1.875 5.5125 1.875 10C1.875 14.4875 5.5125 18.125 10 18.125C14.4875 18.125
        18.125 14.4875 18.125 10C18.125 5.5125 14.4875 1.875 10 1.875ZM12.715
        12.3369H11.7188V13.9587H10.2244V12.3369H6.92375V10.995L10.4225
        5.8725H11.7188V10.9894H12.715V12.3369Z"
        fill="#475569"
      />
    </svg>
  );
}
